import { render, staticRenderFns } from "./ButtonStartVoice.vue?vue&type=template&id=5ce2ce3e&scoped=true&"
import script from "./ButtonStartVoice.vue?vue&type=script&lang=js&"
export * from "./ButtonStartVoice.vue?vue&type=script&lang=js&"
import style0 from "./ButtonStartVoice.vue?vue&type=style&index=0&id=5ce2ce3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2ce3e",
  null
  
)

export default component.exports